module.exports = __webpack_public_path__ + "assets/1e67d06aae186cbfdf068f53fc994aee.png";